import Backbone from 'backbone';

import ElementModel from '../models/ElementModel';

export default Backbone.Collection.extend({
    model: ElementModel,
    comparator: undefined
});



// WEBPACK FOOTER //
// ./~/@girder/large_image_annotation/collections/ElementCollection.js